import { entrypoints } from '@/config/entrypoints'

const { hostname } = window.location
const entrypoint = entrypoints.customs.find(entrypoint => {
  return entrypoint.hostname === hostname
})

const { entry } = entrypoint || entrypoints.default
entry()
